import { Box, FormHelperText, IconButton, InputLabel } from '@mui/material';
import { Editor, EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import React, { useEffect } from 'react';
import FormatBoldIcon from '@mui/icons-material/FormatBold';

const MenuBar = ({ editor }: { editor: Editor | null }) => {
  if (!editor) {
    return null;
  }

  return (
    <IconButton
      onClick={() => editor.chain().focus().toggleBold().run()}
      disabled={!editor.can().chain().focus().toggleBold().run()}
      className={editor.isActive('bold') ? 'is-active' : ''}
      sx={{
        borderRadius: '2px',
        bgcolor: editor.isActive('bold') ? '#5E6366' : '',
        color: editor.isActive('bold') ? 'white' : '#5E6366',
        border: editor.isActive('bold') ? '1px solid' : '1px solid #5E6366',
      }}
    >
      <FormatBoldIcon sx={{ color: 'inherit' }} />
    </IconButton>
  );
};

const extensions = [
  //Color.configure({ types: [TextStyle.name, ListItem.name] }),
  // TextStyle.configure({ types: [ListItem.name] }),
  StarterKit.configure({
    bulletList: {
      keepMarks: true,
      keepAttributes: false,
    },
    orderedList: {
      keepMarks: true,
      keepAttributes: false,
    },
  }),
];

interface IProps {
  label: string | null;
  error?: boolean;
  helperText?: string | null;
  onChange: (htmlContent: string) => void;

  /* eslint-disable-next-line */
  value: any;
  disabled?: boolean;
}

const RichTextInput = ({
  label = null,
  error,
  helperText,
  onChange,
  value,
  disabled = false,
}: IProps) => {
  const editor = useEditor({
    extensions,
    content: value,
    onUpdate: ({ editor }) => onChange(editor.getHTML()),
    editable: !disabled,
  });

  useEffect(() => {
    if (editor && editor?.getHTML() !== value) {
      editor.commands.setContent(value);
    }
  }, [editor, value]);

  return (
    <Box sx={{ width: '100%', margin: '12px 0' }}>
      {label && (
        <InputLabel
          shrink
          sx={{
            color: error ? '#F9473C' : '#5E6366',
            pl: 1,
            '&.Mui-focused': {
              color: error ? '#F9473C' : '#5E6366 !important',
            },
          }}
        >
          {label}
        </InputLabel>
      )}
      <Box sx={{ border: '1px solid #5E6366', p: 2, borderRadius: '8px' }}>
        {!disabled && <MenuBar editor={editor} />}
        <EditorContent editor={editor} />
      </Box>
      {helperText && (
        <FormHelperText sx={{ color: error ? '#F9473C' : '#5E6366' }}>
          {helperText}
        </FormHelperText>
      )}
    </Box>
  );
};

export default RichTextInput;
